var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTextViewer',{attrs:{"text":_vm.editedPatientStory.description},on:{"click:close":function($event){return _vm.$emit('click:close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }